<script>
import {mapActions} from "vuex";

export default {
  name: "AnalyticsFile",
  props: ["file"],
  data: () => ({
    downloading: false,
  }),
  computed: {
    formattedDate() {
      return new Date(this.file.datum).toLocaleDateString('de-DE', {  month: '2-digit', day: '2-digit', year: 'numeric' })
    },
    version() {
      return this.file.version ?? '1';
    }
  },
  methods: {
    ...mapActions('waerme', ['downloadFile']),
    async onDownloadFile() {
      try {
        this.downloading = true;
        await this.downloadFile(this.file.osid);
       } finally {
        this.downloading = false;
      }
    }
  }
}
</script>

<template>
<v-sheet elevation="1" class="mt-3 pa-3">
  <v-row class="document-row" :class="file.isNewEntry ? 'unread-row' : 'read-row'">
    <v-col cols="3" class="py-0 px-2 d-flex align-center" :class="file.isNewEntry ? 'primary-text font-weight-bold' : ''">
      {{ file.commune }}
    </v-col>
    <v-col cols="3" class="py-0 px-2 d-flex align-center" :class="file.isNewEntry ? 'primary-text font-weight-bold' : ''">
      {{ file.kategorie}}
    </v-col>
    <v-col cols="2" class="py-0 px-2 d-flex align-center" :class="file.isNewEntry ? 'primary-text font-weight-bold' : ''">
        {{ formattedDate }}
    </v-col>
    <v-col cols="2" class="py-0 px-2 d-flex align-center">
      <v-btn text small class="mx-0 px-0" @click="onDownloadFile" :loading="downloading">
        <v-icon color="primary" small left>$download</v-icon>
        Herunterladen
      </v-btn>
    </v-col>
    <v-col cols="2" class="py-0 px-2 d-flex align-center" :class="file.isNewEntry ? 'primary-text font-weight-bold' : ''">
      <v-icon left>
        {{ file.isNewEntry ? '$unread' : '$read' }}
      </v-icon>
      {{ file.isNewEntry ? 'Ungelesen' : "Abgerufen"}}
    </v-col>
  </v-row>
  <!--<div class="icon-container" v-if="$vuetify.breakpoint.mdAndUp">
    <v-icon size="70">$thermometer</v-icon>
  </div>
  <div class="px-2" style="flex-grow: 1">
    <div style="width: 100%; display: flex; align-items: center; flex-wrap: wrap">
      <span class="badge analytics-badge px-2">{{ formattedDate }}</span>
      <span class="badge analytics-badge px-2 ml-2">{{ file.commune }}</span>
    </div>
    <p class="primary-text font-weight-bold mb-1">{{ file.thema }} - {{ file.titel }}</p>
    <p style="white-space: break-spaces">{{ file.beschreibung }}</p>
  </div>
  <div class="d-flex flex-column justify-end">
    <v-btn icon color="primary" @click="downloadFile(file.osid)">
      <v-icon>$download</v-icon>
    </v-btn>
  </div>-->
</v-sheet>
</template>

<style scoped>
.icon-container {
  width: 116px;
  height: 116px;
  background: transparent linear-gradient(45deg, #8C0F78 0%, #B40055 100%) 0% 0% no-repeat padding-box;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.analytics-badge {
  height: 17px;
  margin-bottom: 4px;
}

.version-badge {
  color: #1F2B37;
  opacity: 0.3;
}
</style>
